import React, {useEffect, useState} from "react";
import Calendar from "../../../../../components/calendar/Calendar";
import Input from "../../../../../components/inputText/Input";
import Utils from "../../../../../utils/Utils";
import TextArea from "../../../../../components/TextArea/TextArea";
import Spinner from "../../../../../components/spinner/Spinner";
import {setStateAssistente} from "../../../../../actions/IndexActions";
import {useDispatch, useSelector} from "react-redux";

function Valutazione(props){

    const [state,setState] = useState({})
    const [showSpinner,setShowSpinner] = useState(false)
    const dispatch = useDispatch();
    const getAssistente = useSelector(state => state.wizardReducer)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}

    useEffect(() =>{
        if(getAssistente && getAssistente.valutazione && Object.keys(getAssistente.valutazione).length > 0){
            let newState = getAssistente.valutazione
            setState(newState)
        }else{
            setState({
                data:Utils.todayDate(),
                luogo:sessioneUtente && sessioneUtente.sportello? sessioneUtente.sportello.descrizione : "",
                valutazione:""
            })
        }
    },[])

    function riceviValore(id, value){
        setState(Utils.riceviValore(state,id,value))
    }

    function isDataNonValida() {
        return !!(Utils.isValorizzato(state.data) && !Utils.isDateItaValid(state.data))
    }

    useEffect(() =>{
        dispatch(setStateAssistente("valutazione",state))
    },[state, setState])

    return (
        <div>
            <Spinner show={showSpinner}/>
            <div className={"row"}>
                <div className={"col-4"}>
                    <span style={{fontWeight:"bold",fontSize:"16px",color:"#505050"}}>Data Valutazione:</span>
                    <Calendar id={"data"} ariaLabel={"Data Valutazione"} value={state && state.data ? state.data : ""} onChange={riceviValore}
                              errorClause={isDataNonValida()}
                              errorMessage={"La data non è valida"}/>
                </div>
                <div className={"col-4"}>
                    <span style={{fontWeight:"bold",fontSize:"16px",color:"#505050"}}>Luogo Valutazione:</span>
                    <Input id={"luogo"} ariaLabel={"Luogo Valutazione"} value={state && state.luogo ? state.luogo : ""}
                            onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}/>

                </div>
            </div>
            <div style={{marginTop:"1rem"}}>
                <span style={{fontWeight:"bold",fontSize:"16px",color:"#505050"}}>Valutazione:</span>
                <TextArea id={"valutazione"} style={{width: "80%"}} rows={"5"} ariaLabel={"Valutazione"}
                           value={state && state.valutazione ? state.valutazione : ""}
                           onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}/>
            </div>
        </div>
    )

}
export default Valutazione
